export enum CalendarType {
    DAY,
    WEEK,
    MONTH
}
